import { render, staticRenderFns } from "./addDealer.vue?vue&type=template&id=af29d2b6&scoped=true&"
import script from "./addDealer.vue?vue&type=script&lang=js&"
export * from "./addDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af29d2b6",
  null
  
)

export default component.exports